import { css } from '@emotion/react'
import { Trans } from '@lingui/react'
import {
  IconButton,
  InlineButton,
} from '@twistopayments/design-system/components/atoms/button'
import { Hidden } from '@twistopayments/design-system/components/atoms/hidden'
import { TooltipOutlineIcon } from '@twistopayments/design-system/icons/inline'
import { size } from '@twistopayments/design-system/styles'

import { PayInNExplanationModal } from '@twisto/components/organisms/pay-in-n-explanation-modal'
import { useOpen } from '@twisto/hooks'

export const inlineButtonCss = css`
  margin-top: ${size[16]};
`
type Props = {
  maxInstallments: number
}

export const LearnMore = ({ maxInstallments }: Props) => {
  const { isOpen, handleOpen, handleClose } = useOpen()

  return (
    <>
      <Hidden smMdUp>
        <IconButton
          color="ghost"
          icon={TooltipOutlineIcon}
          size="small"
          onClick={handleOpen}
        />
      </Hidden>
      <Hidden smDown>
        <InlineButton
          key="order-info-learn-more"
          css={inlineButtonCss}
          onClick={handleOpen}
        >
          <Trans id="flow.orderInfo.learnMore" />
        </InlineButton>
      </Hidden>

      <PayInNExplanationModal
        maxInstallments={maxInstallments}
        opened={isOpen}
        onClose={handleClose}
      />
    </>
  )
}
